export default `#version 300 es
precision highp float;
#define GLSLIFY 1

vec3 billboard(vec3 position, mat4 viewMatrix) {
    vec3 cameraRight = vec3(viewMatrix[0][0], viewMatrix[1][0], viewMatrix[2][0]);
    vec3 cameraUp = vec3(viewMatrix[0][1], viewMatrix[1][1], viewMatrix[2][1]);

    return position.x * cameraRight + position.y * cameraUp;
}

/**
 * @param size The size of the spritesheet (number of sprites in one row)
 */
vec2 spritesheetUv(vec2 uv, float index, float size) {
    float ii = mod(index, size * size);
    float x = floor(ii / size);
    float y = ii - x * size;

    return vec2(uv.x + x, uv.y + y) / size;
}

in vec3 position;
in vec2 uv;
in mat4 instanceMatrix;
in float instanceIndex;

out vec2 vUv;
flat out float vInstanceIndex;
out float vFragDepth;

uniform mat4 modelMatrix;
uniform mat4 viewMatrix;
uniform mat4 projectionMatrix;

void main() {
    vUv = spritesheetUv(uv, instanceIndex, 4.f);
    vInstanceIndex = instanceIndex;

    vec3 offset = instanceMatrix[3].xyz;
    vec3 scale = vec3(length(instanceMatrix[0].xyz), length(instanceMatrix[1].xyz), length(instanceMatrix[2].xyz));

    gl_Position = projectionMatrix * viewMatrix * modelMatrix * vec4(billboard(position * scale, viewMatrix) + offset, 1.f);
    vFragDepth = 1.f + gl_Position.w;
}`